import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../appState.interface";

export const supplierState = (state: AppStateInterface) => state.supplierState;
export const resultCreateSupplierSelector = createSelector(
    supplierState,
    (state) => state.resultCreateSupplier
)